import {
  ATTACHMENTS_LIST_REQUEST_SUCCESS,
  ATTACHMENTS_LIST_REQUEST_FAIL,
} from '../action.types'
import initialValue from '../initial.state'

export default function (state = initialValue.filesOrderService, action) {
  switch (action.type) {
    case ATTACHMENTS_LIST_REQUEST_SUCCESS:
      return action.payload.values
    case ATTACHMENTS_LIST_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/file/filesOrderService.reducer.js